import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  CircularProgress,
  Box,
} from "@mui/material";

interface AddManualRowDialogProps {
  open: boolean;
  onClose: () => void;
  onAdd: (data: {
    query_text: string;
    quantity: number;
    unit: string;
    code?: string;
    notes?: string;
  }) => Promise<void>;
}

export const AddManualRowDialog: React.FC<AddManualRowDialogProps> = ({
  open,
  onClose,
  onAdd,
}) => {
  const [queryText, setQueryText] = useState("");
  const [quantity, setQuantity] = useState("1");
  const [unit, setUnit] = useState("pz");
  const [code, setCode] = useState("");
  const [notes, setNotes] = useState("");
  const [loading, setLoading] = useState(false);

  const reset = () => {
    setQueryText("");
    setQuantity("1");
    setUnit("pz");
    setCode("");
    setNotes("");
  };

  const handleClose = () => { if (!loading) { reset(); onClose(); } };

  const handleAdd = async () => {
    if (!queryText.trim()) return;
    setLoading(true);
    try {
      await onAdd({
        query_text: queryText.trim(),
        quantity: parseFloat(quantity) || 1,
        unit: unit || "pz",
        code: code.trim() || undefined,
        notes: notes.trim() || undefined,
      });
      reset();
      onClose();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: "1rem", overflow: "hidden" } }}>
      <DialogTitle sx={{ fontWeight: 600 }}>Aggiungi riga manuale</DialogTitle>
      <DialogContent sx={{ overflow: "hidden" }}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5, pt: 1 }}>
          <TextField
            label="Descrizione *"
            value={queryText}
            onChange={(e) => setQueryText(e.target.value)}
            fullWidth
            disabled={loading}
            multiline
            rows={2}
          />
          <Box sx={{ display: "flex", gap: 2 }}>
            <TextField
              label="Quantità"
              value={quantity}
              onChange={(e) => setQuantity(e.target.value)}
              type="number"
              fullWidth
              disabled={loading}
            />
            <TextField
              label="Unità"
              value={unit}
              onChange={(e) => setUnit(e.target.value)}
              fullWidth
              disabled={loading}
            />
          </Box>
          <TextField
            label="Codice articolo (opzionale)"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            fullWidth
            disabled={loading}
          />
          <TextField
            label="Note (opzionale)"
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            fullWidth
            disabled={loading}
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5 }}>
        <Button onClick={handleClose} disabled={loading}>Annulla</Button>
        <Button
          onClick={handleAdd}
          variant="contained"
          disabled={loading || !queryText.trim()}
        >
          {loading ? <CircularProgress size={22} /> : "Aggiungi"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
